import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { DOCUMENT } from '@angular/common';
import { hexToRgb } from './helpers/utils.helper';
import { environment } from 'src/environments/environment';
import { LocationActions } from './store/location/actions';
import { PdvActions } from './store/pdv/actions';
import { ScriptService } from './services/script.service';
import { map, filter } from 'rxjs';
import { PdvSelectors } from './store/pdv/selectors';
import { HelperService } from './services/helper.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  company$ = this.store.pipe(
    select(PdvSelectors.selectCompany),
    map((company) => company ?? null)
  );

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store,
    private helperService: HelperService,
    @Inject(DOCUMENT) private document: Document,
    private scriptService: ScriptService,
    private router: Router
  ) { }

  ngOnInit() {
    this.loadTheme();
    this.store.dispatch(PdvActions.loadPdv());
    this.store.dispatch(LocationActions.loadCities());

    this.activatedRoute.queryParams.subscribe((res: any) => {
      if (res.ref == 'app') {
        sessionStorage.setItem('app', 'yes')
      }
    });

    this.activatedRoute.queryParams.subscribe((params) => {
      if (params["login"] && params["login"] == "true" && document.location.host.replace('www.', '').startsWith("comissario.meubilhete.com.br")) {
        window.location.href = "https://comissario.meubilhete.com.br/auth/login"
      }
    });

    this.activatedRoute.queryParams.subscribe((params) => {
      if (params["login"] && params["login"] == "true" && document.location.host.replace('www.', '').startsWith("produtor.meubilhete.com.br") && this.router.url.split('?')[0] != "/auth/login") {
        window.location.href = "https://produtor.meubilhete.com.br/auth/login?login=true"
      }

      if (params["login"] && params["login"] == "true" && document.location.host.replace('www.', '').startsWith("produtor.ingressosa.com") && this.router.url.split('?')[0] != "/auth/login") {
        window.location.href = "https://produtor.ingressosa.com/auth/login?login=true"
      }
    });

    // this.company$.subscribe((res) => {
    //   if (res?.id == "c51c9b70-b692-42cb-9821-0945f72f8a2e") {
    //     var script = document.createElement('script');
    //     script.type = "text/javascript";
    //     script.src = "https://cdn.pulse.is/livechat/loader.js"
    //     script.setAttribute("data-live-chat-id", "67a6264a9ad30cdfa30fd3e7")
    //     script.async = true  
    //     var head = document.getElementsByTagName('head')[0];
    //     head.appendChild(script);
    //   }
    // })

    this.scriptService.defineDefaultMeta()

    const riskifiedStoreDomain = environment.riskifiedStoreDomain ?? null;

    if (!riskifiedStoreDomain) {
      console.warn('[Riskified] Store domain não configurado');
    } else {
      this.scriptService.loadRiskifiedBeacon(riskifiedStoreDomain);
    }

    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe((e) => {
      if (typeof window !== 'undefined' && window.RISKX?.go) {
        window.RISKX.go(e.urlAfterRedirects || e.url);
      }
    });

    this.company$.subscribe((res) => {
      if (res?.googleAnalyticsKey != null) {
        this.scriptService.loadAnalytics(res.googleAnalyticsKey, "geral")
      }
    })


    // this.activatedRoute.queryParams.subscribe(params => {
    //   let items = this.helperService.getUtm(params)
    //   this.activatedRoute.queryParams.subscribe((value: any) => {
    //     if (value.tag != null) {
    //       if (items != "" && items != null && items.indexOf("utm_campaign") >-1) {
    //         sessionStorage.setItem("utm", items)
    //         window.history.pushState("", "", '/'+value.tag+"?"+items);
    //       } else {
    //         window.history.pushState("", "", '/'+value.tag);
    //       }
    //     }
    //   });
    // });

  }

  loadTheme(): void {
    if (this.document) {
      const primaryColor = environment.primaryColor;
      const btnSecondaryColor = environment.secondaryColor;
      const primaryColorRGB = hexToRgb(primaryColor);

      (document.getElementsByClassName("favIcon")[0] as any).href = environment.favicon
      document.documentElement.style.setProperty('--bs-primary', primaryColor);
      document.documentElement.style.setProperty('--bs-secondary', btnSecondaryColor);
      document.documentElement.style.setProperty('--swiper-navigation-color', primaryColor);
      document.documentElement.style.setProperty('--bs-link-color-rgb', `${primaryColorRGB.r}, ${primaryColorRGB.g}, ${primaryColorRGB.b}`);
      document.documentElement.style.setProperty('--bs-link-hover-color-rgb', `${primaryColorRGB.r}, ${primaryColorRGB.g}, ${primaryColorRGB.b}`);
    }
  }
}
